<video controls preload="true" autoplay muted #videoRef>
    <source src="/assets/video/{{src}}.mp4" type="video/mp4">
    Your browser does not support HTML video.
</video>